import React from "react";
import { Link } from "react-router-dom";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";

function MdLink({ href = "", children }) {
  if (href.startsWith("/")) return <Link to={href}>{children}</Link>;
  return <a href={href} target="_blank" rel="noopener noreferrer">{children}</a>;
}

export const LegalMarkdown = ({ text, testId, className = "" }) => (
  <div className={className} data-testid={testId}>
    <ReactMarkdown remarkPlugins={[remarkGfm]} components={{ a: MdLink }}>{text || ""}</ReactMarkdown>
  </div>
);
